import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
import Layout from "@/views/layouts/index.vue";

export const accountsPayableRouter: RouteRecordRaw[] = [
    {
        path: "/accountsPayable",
        name: "AccountsPayableIndex",
        component: Layout,
        redirect: "/accountsPayable",
        meta: {
            title: "应收应付"
        },
        children: [
            {
                path: "/receivables",
                name: "Receivables",
                meta: { title: "应收管理", pageType: PAGE_TYPE.LIST.code },
                component: () => import("@/views/pages/receivables/index.vue")
            },
            {
                path: "/receivables/detail",
                name: "ReceivablesDetail",
                meta: { title: "应收款详情", hidden: true, activeMenu: "Receivables" },
                component: () => import("@/views/pages/receivables/detail.vue")
            },
            {
                path: "/accountsPayable",
                name: "AccountsPayable",
                meta: { title: "应付管理", pageType: PAGE_TYPE.LIST.code },
                component: () => import("@/views/pages/accountsPayable/index.vue")
            },
            {
                path: "/accountsPayable/detail",
                name: "AccountsPayableDetail",
                meta: { title: "应付款详情", hidden: true, activeMenu: "AccountsPayable" },
                component: () => import("@/views/pages/accountsPayable/detail.vue")
            }
        ]
    }
];

export default accountsPayableRouter;
